import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllOrders } from '../api';
import { setOrders } from '../context/actions/ordersActions';
import OrderData from './OrderData';
import { motion } from "framer-motion";
import Loading from './Loading';

const DBOrders = () => {
  const orders = useSelector((state) => state.orders);
  const dispatch = useDispatch();
  const user = useSelector(state => state.user);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [selectedDate, setSelectedDate] = useState(''); // State to store the selected date
  const [isLoading, setIsLoading] = useState(false); // State to store the selected date
  const [totalMoney, setTotalMoney] = useState(0);
  const [listProductSales, setListProductSales] = useState([])
  const [listProductSalesActive, setListProductSalesActive] = useState(false)
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const formatCurrency = (amount) => {
    // Customize options as needed
    const formatter = new Intl.NumberFormat('vi-VN', {
      style: 'currency',
      currency: 'VND',
    });
    return formatter.format(amount);
  };

  // Sorting 
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });

  const handleSort = (key) => {
    const direction =
      key === sortConfig.key && sortConfig.direction === 'ascending'
        ? 'descending'
        : 'ascending';

    setSortConfig({ key, direction });
  };

  const sortedList = () => {
    if (sortConfig.key && sortConfig.key !== 'total') {
      const sortedData = [...listProductSales].sort((a, b) => {
        const order = sortConfig.direction === 'ascending' ? 1 : -1;
        return a[sortConfig.key] > b[sortConfig.key] ? order : -order;
      });
      return sortedData;
    } else if (sortConfig.key === 'total') {
      console.log(listProductSales)
      const sortedData = [...listProductSales].sort((a, b) => {
        const order = sortConfig.direction === 'ascending' ? 1 : -1;
        // Dynamically calculate total if it doesn't exist in a or b
        const totalA = a.total || a.price * a.quantity;
        const totalB = b.total || b.price * b.quantity;

        return totalA > totalB ? order : -order;
      });
      return sortedData;
    }
    return listProductSales;
  };

  const calculateTotalMoney = (orders) => {
    let total = 0;
    orders.forEach(order => {
      order.orders.forEach(product => {
        total += parseInt(product.product_price, 10) * (product.quantity || 1);
      });
    });
    return total;
  };

  const handleClearSelectedDate = () => {
    setStartDate('');
    setEndDate('');
  };


  useEffect(() => {
    // Check if there are no orders in the state
    if (orders.orders?.length <= 0) {
      // Check if user data is available
      if (user) {
        // Set loading state to true
        setIsLoading(true);
        // User data is available, fetch orders
        getAllOrders(user)
          .then((data) => {
            // Update state with fetched orders
            dispatch(setOrders(data.orders));
          })
          .catch((error) => {
            // Log any errors that occur during the fetch
            console.error("Error fetching orders:", error);
          })
          .finally(() => {
            // Set loading state back to false, whether the fetch was successful or not
            setIsLoading(false);
          });
      }
    }
  }, [dispatch, orders, user]);



  const handleRefreshData = async () => {
    await getAllOrders(user)
      .then((data) => {
        dispatch(setOrders(data.orders));
      })
      .catch((error) => {
        console.log(error);
      });
    setIsLoading(false)
  }

  let sortedOrders = [];

  try {
    let startDateFilter = new Date(0); // Default to the beginning of time
    let endDateFilter = new Date(); // Default to the current date

    if (startDate) {
      startDateFilter = new Date(startDate);
    }

    if (endDate) {
      // Set the end of the selected date by adjusting it to the last millisecond of the day
      endDateFilter = new Date(endDate);
      endDateFilter.setHours(23, 59, 59, 999);
    }

    const filteredOrders = orders.orders.filter((order) => {
      if (order.order_date && order.order_date._seconds && order.order_date._nanoseconds) {
        const orderDate = new Date(
          order.order_date._seconds * 1000 +
          order.order_date._nanoseconds / 1000000
        );
        return orderDate >= startDateFilter && orderDate <= endDateFilter;
      }
      return false;
    });

    sortedOrders = filteredOrders.sort((a, b) => {
      if (a.order_date && b.order_date) {
        const dateA = new Date(
          a.order_date.seconds * 1000 + a.order_date.nanoseconds / 1000000
        );
        const dateB = new Date(
          b.order_date.seconds * 1000 + b.order_date.nanoseconds / 1000000
        );

        return dateB - dateA;
      }
      return 0;
    });
  } catch (error) {
    console.error('Error filtering orders:', error);
    sortedOrders = [];
  }


  useEffect(() => {
    if (sortedOrders.length > 0) {
      const total = calculateTotalMoney(sortedOrders);
      setTotalMoney(total);
    }
  }, [sortedOrders]);


  const HandleDisplayListProductSales = () => {
    setListProductSalesActive(false);
    let productSales = {};

    sortedOrders.forEach((item) => {
      item.orders.forEach((product) => {
        const productName = product.product_name.charAt(0).toUpperCase() + product.product_name.slice(1);

        // Use a unique key combining product name and price
        const productKey = `${productName}_${product.product_price}`;

        if (productSales[productKey]) {
          // Product already exists, increment the quantity
          productSales[productKey].quantity += 1;
        } else {
          // Initialize the product with quantity 1
          productSales[productKey] = {
            name: productName,
            price: parseFloat(product.product_price),
            quantity: 1
          };
        }
      });
    });

    // Convert the productSales object to an array
    const productList = Object.values(productSales);

    // Sort the productList based on quantity (highest to lowest)
    productList.sort((a, b) => b.quantity - a.quantity);

    // Set the sorted productList to listProductSales state
    setListProductSales(productList);
  };


  // Get tomorrow's date in the format yyyy-mm-dd
  const today = new Date();
  const todayFormatted = today.toISOString().split('T')[0];
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = sortedOrders.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <>
      {!isLoading ? (<>
        <div className='flex items-center justify-center flex-col pt-6 w-full gap-4 '>
          <div className='flex justify-center items-center gap-2'>
            <label htmlFor="startDate">Từ ngày: </label>
            <input
              className='p-2 flex justify-center items-center rounded-md'
              type="date"
              id="startDate"
              name="startDate"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              max={endDate || todayFormatted} // Limit start date based on end date if available
            />

            <label htmlFor="endDate">Đến ngày: </label>
            <input
              className='p-2 flex justify-center items-center rounded-md'
              type="date"
              id="endDate"
              name="endDate"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              min={startDate} // Limit end date based on start date
              max={todayFormatted}
            />

            <motion.button
              whileTap={{ scale: 0.9 }}
              onClick={handleClearSelectedDate}
              className='p-2 border-2 rounded-md bg-gradient-to-b from-slate-50 to-emerald-300'
            >
              Bỏ lọc
            </motion.button>

            <div
              className='py-2 px-4 rounded-md bg-lime-300 cursor-pointer'
              onClick={handleRefreshData}
            >
              Làm mới!!
            </div>
          </div>
          <div className='font-bold bg-yellow-400'>Tổng cộng : <span className='text-red-500'> {parseInt(totalMoney).toLocaleString()} VND</span></div>
          <div className='relative flex justify-center top-0 w-full'>
            <div className='p-2 cursor-pointer bg-blue-500 w-[300px] rounded-md text-white'
              onClick={() => setListProductSalesActive(true)}
            >Danh sách sản phẩm bán trong ngày</div>
            {listProductSalesActive && (
              <div className='absolute z-50 w-[60%] top-0 bg-white flex flex-col px-10 py-6 shadow-lg rounded-lg'>
                <div className='flex justify-end'>
                  <span className='relative px-2 cursor-pointer text-white bg-red-500'
                    onClick={() => HandleDisplayListProductSales()}
                  >X</span>
                </div>
                <table className='min-w-full'>
                  <thead>
                    <tr>
                      <th className='py-2 select-none'>
                        STT
                      </th>
                      <th className='py-2 cursor-pointer select-none' onClick={() => handleSort('name')}>
                        Tên
                      </th>
                      <th className='py-2 cursor-pointer select-none' onClick={() => handleSort('price')}>
                        Đơn giá
                      </th>
                      <th className='py-2 cursor-pointer select-none' onClick={() => handleSort('quantity')}>
                        Số lượng
                      </th>
                      <th className='py-2 cursor-pointer select-none' onClick={() => handleSort('total')}>
                        Thành tiền
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {listProductSales &&
                      sortedList().map((item, index) => (
                        <tr
                          key={`productsales_${index}`}
                          className={`${index % 2 === 0 ? 'bg-gray-100' : 'bg-white'} text-center`}
                        >
                          <td className='py-2'>{index + 1}</td>
                          <td className='py-2'>{item.name}</td>
                          <td className='py-2'>{formatCurrency(item.price)}</td>
                          <td className='py-2'>{item.quantity}</td>
                          <td className='py-2'>{formatCurrency(item.price * item.quantity)}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
          {sortedOrders?.length > 0 ? (
            <>
              {currentItems.map((item, i) => (
                <OrderData
                  key={`orders_${indexOfFirstItem + i}`} // Use the calculated index
                  index={sortedOrders.length - (indexOfFirstItem + i) - 1} // Reverse the index
                  data={item}
                  admin={true}
                />
              ))}
              <div className='flex gap-1 mb-20'>
                {Array.from(
                  { length: Math.ceil(sortedOrders.length / itemsPerPage) },
                  (_, index) => {
                    const pageNumber = index + 1;
                    const isHidden = Math.abs(currentPage - pageNumber) > 10;

                    return (
                      !isHidden && (
                        <motion.button
                          whileTap={{ scale: 1.2 }}
                          key={`paginate_${index}`}
                          onClick={() => paginate(pageNumber)}
                          className={
                            `${currentPage === pageNumber ? 'text-xl bg-white border-2 rounded-md drop-shadow-md font-bold' : ''}`
                          }
                        >
                          {pageNumber}
                        </motion.button>
                      )
                    );
                  }
                )}
              </div>
            </>
          ) : (
            <h1 className='text-[72px] text-headingColor font-bold'>There is no Orders</h1>
          )}
        </div>
      </>) : (<>
        <Loading />
      </>)}
    </>
  );
};

export default DBOrders;
